const STYLE_ID = 'cart-installments-one-line';
const SHOP_PAY_BRAND_STYLE_ID = 'cart-installments-shop-pay-brand';
const SHOP_PAY_BRAND_COLOR = '#fff1db';

function getInstallmentsFontSize() {
  return window.matchMedia('(max-width: 749px)').matches ? 'clamp(9px, 2.65vw, 10px)' : '11px';
}

function getInstallmentsCss(options) {
  options = options || {};
  const fontSize = getInstallmentsFontSize();
  const brandShopPay = !!options.brandShopPay;
  const svgHeight = brandShopPay ? '0.78em' : '1em';
  const contentAlign = brandShopPay ? 'baseline' : 'center';
  const contentGap = brandShopPay ? '0.08em' : '0.25em';
  const contentMarginBottom = brandShopPay ? '0.4em' : '0';
  const installmentsGap = brandShopPay ? '0.04em' : '0.25em';
  const ctaFontSize = brandShopPay
    ? (window.matchMedia('(max-width: 749px)').matches ? 'clamp(8px, 2.35vw, 9px)' : '10px')
    : 'inherit';

  return `
  #shopify-installments-content {
    display: flex !important;
    flex-flow: row nowrap !important;
    align-items: ${contentAlign} !important;
    gap: ${contentGap} !important;
    white-space: nowrap !important;
    font-size: ${fontSize} !important;
    line-height: 1.25 !important;
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: ${contentMarginBottom} !important;
  }

  #shopify-installments-content > * {
    flex: 0 0 auto !important;
    white-space: nowrap !important;
  }

  #shopify-installments {
    display: inline-flex !important;
    flex-flow: row nowrap !important;
    align-items: ${contentAlign} !important;
    gap: ${installmentsGap} !important;
    white-space: nowrap !important;
    margin: 0 !important;
  }

  #shopify-installments * {
    white-space: nowrap !important;
  }

  #shopify-installments p,
  #shopify-installments span,
  #shopify-installments-cta {
    line-height: 1.25 !important;
  }

  #shopify-installments svg {
    display: inline-block !important;
    height: ${svgHeight} !important;
    max-height: ${svgHeight} !important;
    width: auto !important;
    vertical-align: baseline !important;
    flex-shrink: 0 !important;
    ${brandShopPay ? 'transform: translateY(0.08em) !important;' : ''}
  }

  #shopify-installments-cta {
    display: inline !important;
    white-space: nowrap !important;
    margin: 0 !important;
    flex-shrink: 0 !important;
    font-size: ${brandShopPay ? ctaFontSize : 'inherit'} !important;
    line-height: 1.25 !important;
    ${brandShopPay ? 'padding-left: 3px !important;' : ''}
  }
`;
}

const SHOP_PAY_BRAND_CSS = `
  #shopify-installments svg,
  #shopify-installments svg path,
  #shopify-installments svg rect,
  #shopify-installments svg circle,
  #shopify-installments svg polygon,
  #shopify-installments svg g {
    fill: ${SHOP_PAY_BRAND_COLOR} !important;
    color: ${SHOP_PAY_BRAND_COLOR} !important;
  }
`;

function stripAprFromInstallments(root) {
  const installments = root.querySelector('#shopify-installments');
  if (!installments) return;

  const previous = installments.innerHTML;
  const cleaned = previous.replace(/\s*or\s+0\s*%\s*APR\s*/gi, ' ').replace(/\s{2,}/g, ' ');
  if (cleaned !== previous) {
    installments.innerHTML = cleaned;
  }

  installments.querySelectorAll('*').forEach((node) => {
    if (node.childNodes.length === 1 && node.firstChild?.nodeType === Node.TEXT_NODE) {
      const text = node.textContent.replace(/^or\s+$/i, '').trim();
      if (text !== node.textContent) {
        node.textContent = text;
      }
    }
  });
}

function layoutInstallmentsInline(root) {
  const content = root.querySelector('#shopify-installments-content');
  const installments = root.querySelector('#shopify-installments');
  const cta = root.querySelector('#shopify-installments-cta');
  if (!content) return;

  const brandShopPay = !!root.getElementById(SHOP_PAY_BRAND_STYLE_ID);
  const svgHeight = brandShopPay ? '0.78em' : '1em';
  const contentAlign = brandShopPay ? 'baseline' : 'center';

  content.style.setProperty('display', 'flex', 'important');
  content.style.setProperty('flex-wrap', 'nowrap', 'important');
  content.style.setProperty('align-items', contentAlign, 'important');
  if (brandShopPay) {
    content.style.setProperty('margin-bottom', '0.4em', 'important');
  }

  if (installments) {
    installments.style.setProperty('display', 'inline-flex', 'important');
    installments.style.setProperty('flex-wrap', 'nowrap', 'important');
    installments.style.setProperty('align-items', contentAlign, 'important');
    installments.style.setProperty('white-space', 'nowrap', 'important');
    installments.style.setProperty('margin', '0', 'important');

    installments.querySelectorAll('p, span, b, strong').forEach((node) => {
      node.style.setProperty('display', 'inline', 'important');
      node.style.setProperty('white-space', 'nowrap', 'important');
      node.style.setProperty('margin', '0', 'important');
      node.style.setProperty('line-height', '1.25', 'important');
    });

    installments.querySelectorAll('svg').forEach((svg) => {
      svg.style.setProperty('display', 'inline-block', 'important');
      svg.style.setProperty('height', svgHeight, 'important');
      svg.style.setProperty('max-height', svgHeight, 'important');
      svg.style.setProperty('width', 'auto', 'important');
      svg.style.setProperty('vertical-align', 'baseline', 'important');
      if (brandShopPay) {
        svg.style.setProperty('transform', 'translateY(0.08em)', 'important');
      }
    });
  }

  if (cta) {
    cta.style.setProperty('display', 'inline', 'important');
    cta.style.setProperty('white-space', 'nowrap', 'important');
    cta.style.setProperty('margin', '0', 'important');
    cta.style.setProperty('line-height', '1.25', 'important');
    if (brandShopPay) {
      cta.style.setProperty(
        'font-size',
        window.matchMedia('(max-width: 749px)').matches ? 'clamp(8px, 2.35vw, 9px)' : '10px',
        'important'
      );
      cta.style.setProperty('padding-left', '3px', 'important');
    }
  }
}

function observeInstallmentsContent(root) {
  const content = root.querySelector('#shopify-installments-content');
  if (!content || content.dataset.installmentsObserving) return;

  content.dataset.installmentsObserving = 'true';
  new MutationObserver(() => {
    stripAprFromInstallments(root);
    layoutInstallmentsInline(root);
    if (root.getElementById(SHOP_PAY_BRAND_STYLE_ID)) {
      recolorShopPayLogo(root);
    }
  }).observe(content, {
    childList: true,
    subtree: true,
    characterData: true,
  });
}

function injectInstallmentsStyle(root, options) {
  if (!root) return;

  let style = root.getElementById(STYLE_ID);
  const css = getInstallmentsCss(options);

  if (!style) {
    style = document.createElement('style');
    style.id = STYLE_ID;
    root.appendChild(style);
  }

  style.textContent = css;
}

function injectShopPayBrandStyle(root) {
  if (!root || root.getElementById(SHOP_PAY_BRAND_STYLE_ID)) return;

  const style = document.createElement('style');
  style.id = SHOP_PAY_BRAND_STYLE_ID;
  style.textContent = SHOP_PAY_BRAND_CSS;
  root.appendChild(style);
}

function recolorShopPayLogo(root) {
  if (!root) return;

  root.querySelectorAll('#shopify-installments svg, #shopify-installments svg *').forEach((node) => {
    node.style.setProperty('fill', SHOP_PAY_BRAND_COLOR, 'important');
    node.style.setProperty('color', SHOP_PAY_BRAND_COLOR, 'important');
  });
}

function styleInstallmentsHost(el, options) {
  options = options || {};
  const apply = () => {
    if (!el.shadowRoot?.querySelector('#shopify-installments-content')) return false;

    injectInstallmentsStyle(el.shadowRoot, options);
    if (options.brandShopPay) {
      injectShopPayBrandStyle(el.shadowRoot);
      recolorShopPayLogo(el.shadowRoot);
    }
    stripAprFromInstallments(el.shadowRoot);
    layoutInstallmentsInline(el.shadowRoot);
    observeInstallmentsContent(el.shadowRoot);
    return true;
  };

  if (apply()) return;

  let attempts = 30;

  const tryApply = () => {
    if (apply()) return;

    if (attempts-- > 0) {
      requestAnimationFrame(tryApply);
    }
  };

  tryApply();
}

function styleCartInstallments() {
  document.querySelectorAll('.cart__installments shopify-payment-terms').forEach((el) => {
    styleInstallmentsHost(el);
  });
}

function styleAnticProductInstallments() {
  document
    .querySelectorAll('.product-information.section[data-product-handle="antic-bike"] shopify-payment-terms')
    .forEach((el) => {
      styleInstallmentsHost(el, { brandShopPay: true });
    });
}

function refreshAnticProductInstallmentStyles() {
  document
    .querySelectorAll('.product-information.section[data-product-handle="antic-bike"] shopify-payment-terms')
    .forEach((el) => {
      if (!el.shadowRoot?.querySelector('#shopify-installments-content')) return;
      injectInstallmentsStyle(el.shadowRoot, { brandShopPay: true });
      layoutInstallmentsInline(el.shadowRoot);
    });
}

function styleAllInstallments() {
  styleCartInstallments();
  styleAnticProductInstallments();
}

customElements.whenDefined('shopify-payment-terms').then(styleAllInstallments);
document.addEventListener('DOMContentLoaded', () => {
  styleAllInstallments();

  const summary = document.querySelector('.cart-drawer__summary');
  if (summary) {
    new MutationObserver(() => styleAllInstallments()).observe(summary, {
      childList: true,
      subtree: true,
    });
  }

  const anticProductInfo = document.querySelector(
    '.product-information.section[data-product-handle="antic-bike"]'
  );
  if (anticProductInfo) {
    new MutationObserver(() => styleAnticProductInstallments()).observe(anticProductInfo, {
      childList: true,
      subtree: true,
    });
  }
});
document.addEventListener('cart:update', () => requestAnimationFrame(styleAllInstallments));
window.matchMedia('(max-width: 749px)').addEventListener('change', () => {
  requestAnimationFrame(styleAllInstallments);
  requestAnimationFrame(refreshAnticProductInstallmentStyles);
});
